module.exports = __webpack_public_path__ + "media/images/products/trial-desktop-sidephoto-f6a69790ff7d92c23fd9e67ad023c77b.png";